<mat-radio-group class="d-flex flex-row gap-2 mt-3" [(ngModel)]="selectedCustomerType">
	<mat-radio-button (change)="changeSelectedData(true)" [value]="customerType.PRIVATE"
		>Klient indywidualny
	</mat-radio-button>
	<mat-radio-button (change)="changeSelectedData(false)" [value]="customerType.COMPANY">Firma </mat-radio-button>
</mat-radio-group>

<div class="row w-50 mx-auto mt-3">
	@if (selectedCustomerType() === customerType.PRIVATE) {
		<mat-form-field appearance="outline">
			<mat-label>Wyszukaj</mat-label>
			<input type="text" matInput [matAutocomplete]="autoUser" [formControl]="usersSelect" />
			<mat-autocomplete
				#autoUser="matAutocomplete"
				[displayWith]="displayUsersFn.bind(this)"
				(optionSelected)="selectUser($event)"
			>
				@for (user of filteredUsers(); track user.id) {
					<mat-option [value]="user">
						{{ user.firstName }} {{ user.lastName }}
						@if (user.birth) {
							<span> | {{ user.birth | date: 'dd.MM.yyyy' }}</span>
						}
						@if (user.userContacts[0]?.phone) {
							<span> | {{ user.userContacts[0].phone }}</span>
						}
						@if (user.userContacts[0]?.email) {
							<span> | {{ user.userContacts[0].email }}</span>
						}
					</mat-option>
				}
			</mat-autocomplete>
		</mat-form-field>
	}
	@if (selectedCustomerType() === customerType.COMPANY) {
		<mat-form-field appearance="outline">
			<mat-label>Wyszukaj firmy</mat-label>
			<input type="text" matInput [matAutocomplete]="auto" [formControl]="organizationSelect" />
			@if (selectedCustomerType() === customerType.COMPANY) {
				<mat-hint align="end"> Wpisz NIP, nazwe </mat-hint>
			}
			<mat-autocomplete
				#auto="matAutocomplete"
				[displayWith]="displayFn.bind(this)"
				(optionSelected)="selectOrganization($event)"
			>
				<ng-container>
					@for (organization of filteredOrganizations(); track organization.id) {
						<mat-option [value]="organization">
							{{ organization.name }}
						</mat-option>
					}
				</ng-container>
			</mat-autocomplete>
		</mat-form-field>
	}

	<button
		mat-raised-button
		color="primary"
		class="mt-3"
		[disabled]="
			selectedCustomerType() === customerType.PRIVATE
				? selectedUser() === null
				: selectedOwnerOrganization() === null
		"
		(click)="changeOwner()"
	>
		Zmień
	</button>
</div>

<mat-dialog-actions align="end">
	<button mat-button class="deny-changes-button" (click)="closeDialog()">Porzuć</button>
</mat-dialog-actions>
